import * as React from 'react'
import { Button } from '@shared/components/button'
import cn from 'classnames'

import styles from './Submit.module.scss'

type Props = {
	disabled?: boolean
	classNameBtn?: string
	text: string
	onClick?: () => void
	type?: 'button' | 'submit'
}

export const Submit = ({ text, disabled, type = 'submit', onClick, classNameBtn }: Props) => {
	return (
		<div className={styles.controls}>
			<Button
				type={type}
				disabled={disabled}
				onClick={onClick}
				className={cn(styles.submitButton, classNameBtn)}
			>
				{text}
			</Button>
		</div>
	)
}
